import {
	DocumentGenerationStatus,
	DocumentGenerationStep,
} from '@sharefiledev/doc-gen-pilet-sdk';
import { DataPreFilledType } from '../constants';

export const hasSystemFilledFields = (fields: any[]) =>
	fields?.some(field => field.dataPreFilledType === DataPreFilledType.SourceMapped) ||
	false;

export const hasAnnotations = (fields: any[]) =>
	fields?.some(field => field.type.includes('Annotation')) || false;

export const getDocumentGenerationStatus = (
	numberOfSteps: number
): DocumentGenerationStatus => {
	const status: DocumentGenerationStatus = {
		[DocumentGenerationStep.POPULATE_FIELDS]: false,
		[DocumentGenerationStep.MANUALLY_FILL_FIELDS]: false,
	};
	if (numberOfSteps === 3) {
		return {
			...status,
			[DocumentGenerationStep.POPULATE_FIELDS]: true,
		};
	}
	return status;
};
